
import axios, { AxiosResponse } from 'axios';
import { AllMessageEventsByDateParams } from './calendar.types';

export type CreateTaxCalendarEventDto = {
    eventDate: string;
    formCode: string;
    isActive: boolean;
    textKk: string;
    textRu: string;
    titleKk: string;
    titleRu: string;
    id?: number;
};

export type TaxCalendarMonthEvent = {
    eventDate: string;
    formCode: string;
    text: string;
    title: string;
};

export type TaxCalendarDto = {
    eventDate: string;
    formCode: string;
    id: number;
    isActive: boolean;
    textKk: string;
    textRu: string;
    titleKk: string;
    titleRu: string;
};

export type UpdateTaxCalendarDto = TaxCalendarDto;

/**
 * Создание события налогового календаря
 */
export const createTaxCalendarEvent = (
    token: string | undefined,
    dto: CreateTaxCalendarEventDto
): Promise<AxiosResponse<any>> => {
    return axios.post('/services/isnaportal/api/admin/tax-calendar', dto, {
        headers: token ? { Authorization: token } : undefined,
    });
};

/**
 * Получение списка сообщений/событий по дате
 */
export const getAllMessageEventsByDate = (
    params: AllMessageEventsByDateParams
): Promise<AxiosResponse> => {
    return axios.get('/services/isnaportal/open-api/get-all-message-events-by-date', { params });
};

/**
 * Получение дат с событиями за месяц
 */
export const getMessageEventsInfoForPeriod = (
    currentMonth: string
): Promise<AxiosResponse> => {
    return axios.get(
        `/services/isnaportal/open-api/get-message-events-info-for-period?yearMonth=${currentMonth}`
    );
};

/**
 * Получение событий для админки с пагинацией
 */
export const getCalendarEvents = async (
    token?: string,
    params: Record<string, any> = {}
) => {
    return axios.get('/services/isnaportal/api/admin/tax-calendar/all-by-pagination', {
        headers: { Authorization: token },
        params: { size: 10, ...params },
    });
};

/**
 * Получение списка версий ФНО
 */
export const getFnoVersions = async (): Promise<AxiosResponse<any>> => {
    return axios.get('/services/isnaportal/open-api/tax-rep/get-fno-versions');
};

/**
 * Удаление события
 */
export const deleteTaxCalendarEvent = (
    token: string | undefined,
    id: number
): Promise<AxiosResponse<any>> => {
    return axios.delete(`/services/isnaportal/api/admin/tax-calendar/${id}`, {
        headers: { Authorization: token },
    });
};

/**
 * Редактирование события
 */
export const updateTaxCalendarEvent = (
    token: string | undefined,
    id: number,
    dto: UpdateTaxCalendarDto
): Promise<AxiosResponse<any>> => {
    return axios.put(`/services/isnaportal/api/admin/tax-calendar/${id}`, dto, {
        headers: { Authorization: token },
    });
};

/**
 * Получение всех событий налогового календаря
 */
export const getTaxCalendarAll = (
    token?: string
): Promise<AxiosResponse<TaxCalendarDto[]>> => {
    return axios.get('/services/isnaportal/api/admin/tax-calendar/all', {
        headers: { Authorization: token },
    });
};

/**
 * Получение событий налогового календаря за месяц
 */
export const getTaxCalendarMonth = (params: {
    year: number;
    month: number;
    locale?: 'RU' | 'KK' | 'QQ' | 'EN';
}): Promise<AxiosResponse<TaxCalendarMonthEvent[]>> => {
    return axios.get('/services/isnaportal/api/open-api/tax-calendar', {
        params,
        skipErrorNotification: true,
    });
};
